import { z } from 'zod';

export const AlertEventTypeSchema = z.enum([
  'created',
  'acknowledged',
  'status_changed',
  'asset_assigned',
  'note_added',
  'resolved',
]);
export type AlertEventType = z.infer<typeof AlertEventTypeSchema>;

export const AlertEventSchema = z.object({
  id: z.string().uuid(),
  alertId: z.string().uuid(),
  type: AlertEventTypeSchema,
  payload: z.record(z.unknown()).optional(),
  actorId: z.string().optional(),
  createdAt: z.coerce.date(),
});
export type AlertEvent = z.infer<typeof AlertEventSchema>;
